import { render, staticRenderFns } from "./GalaxyWizard.vue?vue&type=template&id=2aa80912&scoped=true"
import script from "./GalaxyWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GalaxyWizard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GalaxyWizard.vue?vue&type=style&index=0&id=2aa80912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa80912",
  null
  
)

export default component.exports